import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import ReactToPrint from 'react-to-print';
import * as styles from './print-approved-sp.module.scss';
import { BasicButton } from '../../../../assets/common';
import { Spin } from 'antd';
import { isEmpty } from 'lodash';

const PrintApprovedSp = (props) => {
  const { componentRef, positionName, dateApproved, customFileName, style, isDisabled, setIsPrinting } = props;
  const [loading, setLoading] = useState(false);
  const fileName = `SP_${positionName || '-'}_${dateApproved ? moment(dateApproved).format('YYYYMMDD') : ''}`;

  const reactToPrintTrigger = () => {
    return (
      <div className={styles.control}>
        <div className="mt-2">
          <div className="d-flex align-items-center justify-content-end">
            <Spin spinning={loading} size="small">
              <BasicButton disabled={loading || isDisabled} data-testid="printBtn" style={style}>
                Print
              </BasicButton>
            </Spin>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <ReactToPrint
        content={() => {
          const cloneDom = componentRef.current.cloneNode(true);
          const elements = cloneDom.querySelectorAll('.box-card');
          if (!isEmpty(elements)) {
            elements.forEach((el) => {
              el.style.removeProperty('width');
            });
          }
          return cloneDom;
        }}
        removeAfterPrint
        documentTitle={customFileName || fileName}
        onBeforeGetContent={() => {
          setLoading(true);
          setIsPrinting && setIsPrinting(true);
        }}
        onBeforePrint={() => setLoading(false)}
        trigger={reactToPrintTrigger}
        onAfterPrint={() => {
          setIsPrinting && setIsPrinting(false);
        }}
      />
    </div>
  );
};
PrintApprovedSp.propTypes = {
  componentRef: PropTypes.object,
  positionName: PropTypes.string,
  dateApproved: PropTypes.string,
  customFileName: PropTypes.string,
  style: PropTypes.object,
  isDisabled: PropTypes.bool,
  setIsPrinting: PropTypes.func,
};

export default PrintApprovedSp;
